/**
 * SearchBox component for the microreceipt frontend.
 *
 * @module SearchBox
 * @returns {JSX.Element} The SearchBox component.
 */
import React, { useState, useContext } from 'react'
import { Form, Button } from 'react-bootstrap'
import { useNavigate } from 'react-router-dom'
import { ThemeContext } from './ThemeContext.js'

const SearchBox = () => {
  const { theme } = useContext(ThemeContext)
  const [keyword, setKeyword] = useState('')

  const navigate = useNavigate()

  const submitHandler = (e) => {
    e.preventDefault()
    if (keyword.trim()) {
      navigate(`/search/${keyword}`)
    } else {
      setKeyword('')
      navigate('/receipts')
    }
  }

  return (
    <Form className='d-flex' onSubmit={submitHandler}>
      <Form.Control
        type='text'
        name='q'
        onChange={(e) => setKeyword(e.target.value)}
        placeholder='DDMMYYYY'
        className='mr-sm-2 ml-sm-5'
        style={{
          backgroundColor: theme.card,
          color: theme.text,
          borderColor: theme.sidebarAccent
        }}
      />
      <Button
        type='submit'
        variant='outline-primary'
        className='p-2'
        style={{
          borderColor: theme.accent,
          color: theme.accent,
          backgroundColor: 'transparent',
          border: `1px solid ${theme.accent}`
        }}
      >
        Search
      </Button>{' '}
    </Form>
  )
}

export default SearchBox
